var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09411 1.1667C4.09411 1.05895 4.13691 0.955623 4.2131 0.879436C4.28928 0.803249 4.39261 0.760448 4.50036 0.760448C4.6081 0.760448 4.71143 0.803249 4.78762 0.879436C4.86381 0.955623 4.90661 1.05895 4.90661 1.1667L4.90661 6.17711H7.75036C7.83065 6.17719 7.90913 6.20105 7.97587 6.24569C8.04261 6.29034 8.09463 6.35376 8.12535 6.42795C8.15606 6.50214 8.16411 6.58376 8.14846 6.66252C8.13282 6.74128 8.09418 6.81363 8.03744 6.87045L4.78744 10.1204C4.71127 10.1965 4.60801 10.2393 4.50036 10.2393C4.3927 10.2393 4.28945 10.1965 4.21327 10.1204L0.963273 6.87045C0.90653 6.81363 0.867897 6.74128 0.852251 6.66252C0.836605 6.58376 0.844649 6.50214 0.875368 6.42795C0.906086 6.35376 0.958102 6.29034 1.02484 6.24569C1.09159 6.20105 1.17006 6.17719 1.25036 6.17711H4.09411V1.1667Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.659c03506ceeeffe77d3a7d2429177cb.svg";
export { ForwardRef as ReactComponent };